import { render, staticRenderFns } from "./RankingElosDuradouros.vue?vue&type=template&id=22cb66d1&scoped=true&"
import script from "./RankingElosDuradouros.vue?vue&type=script&lang=js&"
export * from "./RankingElosDuradouros.vue?vue&type=script&lang=js&"
import style0 from "./RankingElosDuradouros.vue?vue&type=style&index=0&id=22cb66d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cb66d1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VOverlay,VProgressCircular})
